import axios, { AxiosResponse } from 'axios';
import { put, takeLatest, select , all, takeEvery} from 'redux-saga/effects';
import actions from '@state/actions';
import selectors from '@state/selectors';
import { serverError } from '@state/auth/actions';
import host from '@utils/host';
import * as actionsTypes from './constants';
import * as actionsInterfaces from './types';
import { UserManager } from 'oidc-client';

function* duplicateDesign(action: actionsInterfaces.IDuplicateDesignAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.post(`${host}designs/duplicate`, action.duplicateDesignInfo,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.designs.addSuccessDesign({status:response.status, id:response.data.id, name:response.data.name, design:response.data}));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      yield put(actions.designs.addSuccessDesign({status:response.status, id:response.data.id, name:response.data.name}));
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }  
  }
}

function* createFromTemplate(action: actionsInterfaces.ICreateFromTemplateAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.post(`${host}designs/create-from-template`, action.designRequest, {headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.designs.addSuccessDesign({status:response.status, id:response.data.id, name:response.data.name, design:response.data}));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }  
  }
}

function* createTemplateFromDesign(action: actionsInterfaces.ICreateTemplateFromDesignAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.post(`${host}templates/createFromDesign`, action.createTemplateFromDesignInfo,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.templates.addSuccess({status:response.status, id:response.data.id, name:response.data.name, designName: action.createTemplateFromDesignInfo.designName}));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      yield put(actions.templates.addSuccess({status:response.status, id:response.data.id, name:response.data.name}));
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }  
  }
}

function* fetchDesigns(action: actionsInterfaces.IFetchDesignsAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}designs`    
    if(action.query)callUrl=`${host}designs${action.query}`

    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.designs.setDesigns(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* getDesign(action: actionsInterfaces.IFetchDesignAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}designs`    
    if(action.query)callUrl=`${host}designs${action.query}`
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.designs.setDesign(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* getDesignAuth(action: actionsInterfaces.IFetchDesignAuthAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.get(`${host}design-auth/${action.id}`,{ headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.designs.setDesignAuth(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* addDesign(action: actionsInterfaces.IPostDesignAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.post(`${host}designs`, action.design,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.designs.addSuccessDesign({status:response.status, id:action.design.id, name:action.design.name, design:response.data}));
      if (action.callback) { action.callback(response.data[0]); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      yield put(actions.designs.addSuccessDesign({status:response.status, id:action.design.id, name:action.design.name}));
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* fetchSearchDesigns(action: actionsInterfaces.IFetchDesignsAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}designs`    
    if(action.query)callUrl=`${host}designs${action.query}`
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.designs.setSearchDesigns(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* updateDesign(action: actionsInterfaces.IUpdateDesignAction | actionsInterfaces.IUpdateDesignDeleteAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.put(`${host}designs/${action.design.id}/${action.updateFolderCounter??false}`,action.design,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      if (action.location==='FAVORITES') yield put(actions.designs.addDesignSuccessFavorite({status:response.status, id:action.design.id, favorite:action.design.favorite, name:action.design.name}));
      if (action.callback) { action.callback(response); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* updateDesignAuth(action: actionsInterfaces.IUpdateDesignAuthAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.put(`${host}design-auth/${action.designAuth.id}`, action.designAuth, {headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.designs.setDesignAuth(response.data.designAuth, response.data.designAuthMailErrors));
      if (action.callback) { action.callback(response.data); }
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* requestAccess(action: actionsInterfaces.IRequestAccessAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.post(`${host}design-access`, action.designAccess, {headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      if (action.callback) { action.callback(response.data); }
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      if (action.callback) { action.callback(undefined, response); }
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* fetchDesignCounters(action: actionsInterfaces.IFetchDesignCountersAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}design-counters/${action.userEmail}/${action.sharedFiles}`
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      if (action.sharedFiles) yield put(actions.designs.setCounterSharedFiles(response.data));
      else yield put(actions.templates.setCounter(response.data[0]));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* fetchCounter(action: actionsInterfaces.IFetchCounterAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}designscount`    
    if(action.filter)callUrl=`${host}designscount${action.filter}`
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.designs.setCounterDesigns(response.data[0]));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* updateDesigns(action: actionsInterfaces.IUpdateDesignsAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.post(`${host}designs-update`,action.designs,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      if (action.callback) { action.callback(response); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* updateDesignsFields(action: actionsInterfaces.IUpdateDesignsFieldsAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.post(`${host}designs-update-fields`,action.updateInfo,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      if (action.callback) { action.callback(response); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

export default function* budgetSagas() {
  yield all([
    takeLatest(actionsTypes.DUPLICATE_DESIGN, duplicateDesign),
    takeLatest(actionsTypes.CREATE_FROM_TEMPLATE, createFromTemplate),
    takeLatest(actionsTypes.CREATE_TEMPLATE_FROM_DESIGN, createTemplateFromDesign),
    takeEvery(actionsTypes.FETCH_DESIGNS, fetchDesigns),
    takeLatest(actionsTypes.GET_DESIGN_INFO, getDesign),
    takeLatest(actionsTypes.GET_DESIGN_AUTH, getDesignAuth),
    takeEvery(actionsTypes.ADD_DESIGN, addDesign),
    takeLatest(actionsTypes.FETCH_SEARCH_DESIGNS, fetchSearchDesigns),
    takeLatest(actionsTypes.FETCH_DESIGN_COUNTERS, fetchDesignCounters),
    takeEvery(actionsTypes.UPDATE_DESIGN, updateDesign),
    takeEvery(actionsTypes.UPDATE_DESIGN_DELETE, updateDesign),
    takeLatest(actionsTypes.UPDATE_DESIGN_AUTH, updateDesignAuth),
    takeLatest(actionsTypes.REQUEST_ACCESS, requestAccess),
    takeLatest(actionsTypes.UPDATE_DESIGNS, updateDesigns),
    takeLatest(actionsTypes.UPDATE_DESIGNS_FIELDS, updateDesignsFields),
    takeLatest(actionsTypes.FETCH_COUNTER_DESIGNS, fetchCounter)
  ])
}

